module.exports = __webpack_public_path__ + "img/08.6552df71.png";